/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Social",
  size: 20
}

const SvgSocial = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path fill="none" strokeWidth={1.1} d="M13.4 14l-7.1-3.3M13.5 5.5l-7 3.3" />
    <circle fill="none" strokeWidth={1.1} cx={15.5} cy={4.6} r={2.3} />
    <circle fill="none" strokeWidth={1.1} cx={15.5} cy={14.8} r={2.3} />
    <circle fill="none" strokeWidth={1.1} cx={4.5} cy={9.8} r={2.3} />
  </Svg>
)

SvgSocial.defaultProps = defaultProps
export default SvgSocial
